type AgeType = 'lateTeens' | '20s' | '30s' | '40s' | '50s+';

export function formatAge(ageType: AgeType) {
    switch (ageType) {
        case 'lateTeens':
            return '18-19';
        case '50s+':
            return '50s +';
        default:
            return ageType;
    }
}
